import { Withdrawal as Withdrawals } from './Withdrawal';

export default Withdrawals;
